export const CURATED_HERO_COMPONENT = 'CuratedHero';
